import type {CandlestickData, Time, WhitespaceData} from 'lightweight-charts';

export type CandlestickTimelineItem = CandlestickData<Time> | WhitespaceData<Time>;

/**
 * 为 AI 计划范围补齐未来时间槽。
 * 空白点只提供 time，不伪造 OHLC/成交量；真实 K 线到达后下次 setData 会自然替换对应空白槽。
 */
export function appendFutureCandleWhitespace(
    candles: readonly CandlestickData<Time>[],
    intervalMs: number,
    throughTimeMs: number | null,
): CandlestickTimelineItem[] {
    const timeline: CandlestickTimelineItem[] = [...candles];
    if (0 === candles.length || null == throughTimeMs
        || !Number.isFinite(intervalMs) || intervalMs <= 0
        || !Number.isFinite(throughTimeMs) || throughTimeMs <= 0) {
        return timeline;
    }

    const lastTime = candles[candles.length - 1].time;
    if ('number' !== typeof lastTime) return timeline;

    const intervalSeconds = intervalMs / 1000;
    const throughSeconds = Math.floor(throughTimeMs / 1000);
    for (let time = lastTime + intervalSeconds; time <= throughSeconds; time += intervalSeconds) {
        timeline.push({time: time as Time});
    }
    return timeline;
}
